import { render, staticRenderFns } from "./EditTaxGroupPage.vue?vue&type=template&id=5a1d3598"
import script from "./EditTaxGroupPage.vue?vue&type=script&lang=js"
export * from "./EditTaxGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports